// extracted by mini-css-extract-plugin
export default {"container":"_5aR5A","slide":"W9lIk","postWrapper":"F7SQb","withoutFooter":"vFgUX","separator":"CmaNp"};